export default __webpack_public_path__ + "static/media/result-graph.5bedacc0.svg";